module.exports = __webpack_public_path__ + "static/media/fly0195.bdc8df60.webp";